import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, CompanyFullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { RoutingID } from '../../../../routes/sb-routing-enum';
import { NavigationService } from '@ngx-seatback/utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-page-company-details-overview',
  templateUrl: './company-details-overview.component.html',
  styleUrls: ['./company-details-overview.component.scss'],
  standalone: false,
})
export class CompanyDetailsOverviewComponent implements OnInit {
  companyId: number;
  company: CompanyFullDTO;

  loading: boolean;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public navService: NavigationService,
    private destroyRef: DestroyRef
  ) {
    this.companyId = undefined;
    this.company = undefined;
    this.loading = true;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.companyId = +params.companyID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .shared_Company_retrieveCompanyById(this.companyId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: CompanyFullDTO) => {
          this.company = e;
        },
        error: error => {
          if (error.status && (+error.status === 403 || +error.status === 404)) {
            this.navService.navigateToPoint(RoutingID.companies);
          } else {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }

  getSelectedCompanyCoords() {
    if (this.company?.address?.position) {
      return { x: this.company.address.position.coordinates[0], y: this.company.address.position.coordinates[1] };
    }
  }
}
